<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright">
<p class="nonindent6"><span class="big2">make me I’m yours…</span></p>
<h1 class="subtitle"><em>sewing</em></h1>
<p class="center">compiled by Cheryl Brown</p>
<p class="center8"><img alt="" src="OEBPS/images/logo.gif"/></p>
<p class="center"><a class="hlink" href="http://www.rucraft.co.uk" target="_blank">www.rucraft.co.uk</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?40b8e718